/** The colour a status badge speaks in. */
export enum StatusTone {
    Success = 'success',
    Warning = 'warning',
    Danger = 'danger',
    Neutral = 'neutral',
    /** A camera recording: the red dot of the cameras list, on a quiet background. */
    Recording = 'recording',
}
